import axios from "axios";

/* DEV  */
// export const API_UR = 'http://127.0.0.1:8000';
// export const API_UR = 'http://192.168.1.70:8000';
export const API_URL = "http://127.0.0.1:3001/api";

/*images HEALTH status PROD*/
// export const API_URL = 'https://customerapi.papasandbeer.com/api';
/*images HEALTH status DEV*/
// export const API_URL = 'http://api-customers.wenatives.com/api';

/*  PROD  */
export const API_UR = "https://api.lvinlife.com";

/* test */
// export const API_UR = 'https://stg-api.lvinlife.com';

export const API_KEY_STRIPE = "pk_live_51SGmAL6H5GFbwl1ZFCuLqUa5iY3UueNqlS73ALv2bhSFxCbynCvg0pDndY6w9LuRF9XTyjQJKteOlmyyKt0DCW2100xnkgACEb";
// export const API_KEY_STRIPE = 'pk_test_51MBmJfL1kOuLIvotsX3rc9O5hFhPCg0VySoFAWwdQ21PMlExnPyZCKd1bPaO8vYJjMOePbYZ7POR5VLqusx5ILTi000oyOqLqU';
// export const API_KEY_STRIPE = 'pk_test_51SGmAL6H5GFbwl1Zj8BlI8yYJiUZUPBiIh2xGJ6GiOQBNh92Xnwzf442TWUrUJzuA0KY4y1tE28UAw8eEVYnF9E600YhLC27Ac';
// export const API_KEY_STRIPE = 'pk_test_F5otdRmIj0e4buAsu6EGszwt';

export const request = axios.create({
  baseURL: API_UR,
  responseType: "json",
});

export const api = () => {
  let token = localStorage.getItem("ses-tok-pa-evt");

  token = JSON.parse(token);

  let AuthorizationToken = token.token_type + " " + token.access_token;

  return axios.create({
    baseURL: API_UR + "/api",
    responseType: "json",
    headers: { Authorization: AuthorizationToken },
  });
};

export const api_file = () => {
  let token = localStorage.getItem("ses-tok-pa-evt");

  token = JSON.parse(token);

  let AuthorizationToken = token.token_type + " " + token.access_token;

  return axios.create({
    baseURL: API_UR + "/api",
    responseType: "blob",
    headers: {
      Authorization: AuthorizationToken,
      "Content-Type": "multipart/form-data",
    },
  });
};
